import { MessageComponent } from '@syncfusion/ej2-react-notifications';
import { clearPurpose } from "../utils/Purpose";
import React, { useEffect, useState } from 'react';
import { env } from '../env'
export default function FormCompleted(props) {
    // Declare variables using const or let
    const { session, storageValues } = props; 

    // Declare state variables using useState
    const [isStayingOnPage, setIsStayingOnPage] = useState(false);

    // Declare effects using useEffect
    useEffect(() => {
        document.title = 'CPA - Completed';
    }, []);

    useEffect(() => {
        if (env.VITE_ENV && env.VITE_ENV.toLowerCase() !== 'production') {
            console.log(`FormCompleted.useEffect :: []`);
        }

        clearPurpose(storageValues);
        if (session && session.returnUrl !== null && session.returnUrl !== '') {
            window.location.href = session.returnUrl;
        } else {
            setIsStayingOnPage(true);
        }

    }, []);

    return (
        <div>
            <div className="row">
                <div className="e-card">
                    <div className="e-card-content">
                        <div className="col-xs-12 mt-2">
                            {!isStayingOnPage && <MessageComponent severity="None" variant="Outline" content="Redirecting."></MessageComponent >}
                            {isStayingOnPage && <MessageComponent severity="Success" variant="Outline" content="Your submission was received and will be processed, Thank you for supporting this campaign, you may close the browser."></MessageComponent >}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
